<div class="side-bar-nav no-print">
  <div class="wizard-menu" *ngIf="displayMenu !== null"></div>

  <div class="option-menu" *ngFor="let item of listItems">
    <div
      #sideWeb
      class="menu-item sidenav-item"
      *ngIf="hasAuth(item)"
      (click)="openRightPanel(item)"
      [ngClass]="{'selected' : item.id === selectedId}"
    >
      <div class="menu-item-wrapper">
        <mat-icon [ngClass]="item.icon"></mat-icon>
        <div class="sidebar-title">{{item.title}}</div>
      </div>
    </div>
  </div>
</div>
